type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';
interface RequestOptions {
  headers?: any;
  method?: HttpMethod;
  body?: any;
  [key: string]: any;
}
class HttpCallBase {
  private baseURL: string;
  constructor(baseURL: string) {
    this.baseURL = baseURL;
  }
  private callApi(
    url: string,
    method: HttpMethod,
    body: any = null,
    isFormData: boolean = false,
    options: RequestOptions | null = null
  ): Promise<any> {
    url = this.baseURL + url;
    const requestHeaders = new Headers();
    requestHeaders.set(
      'Content-Type',
      isFormData ? 'multipart/form-data' : 'application/json'
    );
    requestHeaders.set('Cache-Control', 'no-store, no-cache, must-revalidate');
    requestHeaders.set('Pragma', 'no-cache');
    requestHeaders.set('Expires', '0');
    const requestInfo: RequestOptions = {
      method,
      headers: requestHeaders,
      ...(method === 'POST' || method === 'PUT'
        ? { body: isFormData ? body : JSON.stringify(body) }
        : {}),
      ...(options || {}),
    };
    return new Promise((resolve, reject) => {
      fetch(url, requestInfo)
        .then(async response => {
          const contentType = response.headers.get('content-type') || '';

          if (response.status !== 200) {
            if (response.status === 401) {
              return reject('Please check your permission');
            }

            const raw = await response.text();
            if (contentType.includes('application/json')) {
              try {
                const obj = JSON.parse(raw);
                return reject(JSON.stringify(obj));
              } catch {
                return reject(
                  `HTTP ${response.status} at ${url}: invalid JSON response`
                );
              }
            }

            return reject(
              `HTTP ${response.status} at ${url}: ${raw.slice(0, 200)}`
            );
          }

          if (contentType.includes('application/json')) {
            return resolve(response.json());
          }

          const raw = await response.text();
          return resolve(raw);
        })
        .catch(ex => {
          console.error(ex);
          if (ex.toString() === `TypeError: Failed to fetch`) {
            return reject(`${ex.toString()} ${url}`);
          }
          if (ex.name === 'AbortError') {
            return;
          }
          console.log(`failed to fetch URL ${url}`);
          return reject(ex);
        });
    });
  }

  public httpGet(
    path: string,
    options: RequestOptions | null = null
  ): Promise<any> {
    return this.callApi(path, 'GET', null, false, options);
  }

  public httpPost(
    path: string,
    body: any,
    options: RequestOptions | null = null
  ): Promise<any> {
    return this.callApi(path, 'POST', body, false, options);
  }
  public httpPut(
    path: string,
    body: any,
    options: RequestOptions | null = null
  ): Promise<any> {
    return this.callApi(path, 'PUT', body, false, options);
  }
  public httpDelete(
    path: string,
    options: RequestOptions | null = null
  ): Promise<any> {
    return this.callApi(path, 'DELETE', null, false, options);
  }
  public httpPostFormData(
    path: string,
    body: any,
    options: RequestOptions | null = null
  ): Promise<any> {
    return this.callApi(path, 'POST', body, true, options);
  }
  public httpPutFormData(
    path: string,
    body: any,
    options: RequestOptions | null = null
  ): Promise<any> {
    return this.callApi(path, 'PUT', body, true, options);
  }
}
const BaseApi_Prefix = '/api/landingpage';

const getServerBaseUrl = () => {
  return (
    process.env.API_BASE_URL ||
    process.env.NEXT_PUBLIC_LOCAL_BASE_URL ||
    process.env.NEXT_PUBLIC_DOMAIN_BASE_URL ||
     'http://localhost:6001' 
  );
};

const getClientBaseUrl = () => {
  return getServerBaseUrl();
};

class HttpServerCall extends HttpCallBase {
  constructor() {
    super(`${getServerBaseUrl()}${BaseApi_Prefix}`);
  }
}
export const HttpServer = new HttpServerCall();
export class HttpClientCall extends HttpCallBase {
  constructor() {
    super(`${getClientBaseUrl()}${BaseApi_Prefix}`);
  }
}
export const HttpClient = new HttpClientCall();
